module.exports = __webpack_public_path__ + "img/csr.00b06efb.webp";